<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SLAMetricCard from './SLAMetricCard.vue';
import DoughnutChart from 'shared/components/charts/DoughnutChart.vue';

const props = defineProps({
  hitRate: {
    type: String,
    required: true,
  },
  noOfBreaches: {
    type: Number,
    required: true,
  },
  noOfConversations: {
    type: Number,
    required: true,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();

const hasChartData = computed(() => props.noOfConversations > 0);

const chartCollection = computed(() => ({
  labels: [
    t('SLA_REPORTS.METRICS.CHART.HIT'),
    t('SLA_REPORTS.METRICS.CHART.MISSED'),
  ],
  datasets: [
    {
      data: [
        Math.max(props.noOfConversations - props.noOfBreaches, 0),
        props.noOfBreaches,
      ],
      backgroundColor: ['rgb(107, 201, 103)', 'rgb(236, 11, 67)'],
    },
  ],
}));
</script>

<template>
  <div
    class="flex sm:flex-row flex-col w-full gap-4 sm:gap-14 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5"
  >
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.HIT_RATE.LABEL')"
      :value="hitRate"
      :tool-tip="$t('SLA_REPORTS.METRICS.HIT_RATE.TOOLTIP')"
      :is-loading="isLoading"
    />

    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.LABEL')"
      :value="noOfBreaches"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_MISSES.TOOLTIP')"
      :is-loading="isLoading"
    />
    <div class="w-full sm:w-px bg-n-strong" />
    <SLAMetricCard
      :label="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.LABEL')"
      :value="noOfConversations"
      :tool-tip="$t('SLA_REPORTS.METRICS.NO_OF_CONVERSATIONS.TOOLTIP')"
      :is-loading="isLoading"
    />
    <template v-if="!isLoading && hasChartData">
      <div class="w-full sm:w-px bg-n-strong" />
      <div class="w-full shrink-0 h-28 sm:w-40">
        <DoughnutChart :collection="chartCollection" />
      </div>
    </template>
  </div>
</template>
